import { useMutation } from '@apollo/client'
import { EditGroupMember, EditGroupMemberVariables } from '../../types'
import { EDIT_GROUP_MEMBER } from './operations'

export const useEditGroupMember = () =>
  useMutation<EditGroupMember, EditGroupMemberVariables>(EDIT_GROUP_MEMBER)
